import Page from "./ScanningResult";

export default Page;
